import React, { useState } from "react";
import { Play } from "lucide-react";
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from "./ui/dialog";

// In-app YouTube viewer. Wrap any trigger element as children.
export default function VideoModal({ videoId, title = "Video", children }) {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className="max-w-4xl w-[94vw] bg-black border-[var(--line)] p-0 overflow-hidden">
        <div className="aspect-video w-full bg-black">
          {open && (
            <iframe
              className="w-full h-full"
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`}
              title={title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          )}
        </div>
        <div className="flex items-center justify-between gap-3 px-5 py-3 bg-black border-t border-[var(--line)]">
          <span className="text-xs text-[var(--muted)] truncate">{title}</span>
          <a
            href={`https://www.youtube.com/watch?v=${videoId}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs font-semibold text-[var(--gold)] hover:underline whitespace-nowrap"
          >
            Open on YouTube
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
}

// A clickable thumbnail with a red play button overlay.
export function VideoThumb({ videoId, title, className = "" }) {
  return (
    <VideoModal videoId={videoId} title={title}>
      <button
        className={`group relative block w-full overflow-hidden rounded-2xl border border-[var(--line)] bg-black ${className}`}
        aria-label={`Play ${title}`}
      >
        <img
          src={`https://img.youtube.com/vi/${videoId}/hqdefault.jpg`}
          alt={title}
          className="w-full h-full object-cover aspect-video transition-transform duration-700 group-hover:scale-105"
        />
        <span className="absolute inset-0 bg-black/30 group-hover:bg-black/20 transition-colors" />
        <span className="absolute inset-0 flex items-center justify-center">
          <span className="w-16 h-16 rounded-full bg-[var(--gold)] flex items-center justify-center shadow-[0_10px_40px_-8px_rgba(229,18,30,0.8)] transition-transform duration-300 group-hover:scale-110">
            <Play size={26} className="text-white ml-1" fill="currentColor" />
          </span>
        </span>
      </button>
    </VideoModal>
  );
}
